import { FormEvent, useContext, useEffect, useState } from "react";
import { ModalEstadoContext } from "../../contexts/ModalEstado";
import { Button, Loader } from "../Styles";
import { IoIosDocument, IoMdDownload } from "react-icons/io";
import { MdDelete, MdOpenInNew, MdAutorenew } from "react-icons/md";
import { toast } from "react-toastify";
import { cadastrarDocumentoProjeto, listarProjetosDocumentos, deletarDocumentoController, substituirDocumentoProjeto } from "../../services/projetosDocumentos"
import { paramsListaDocumentos } from "../../interfaces/projetosDocumentos";
import { criptografarDado } from "../../helpers";
import "./index.css"
import { useLocation } from 'react-router-dom';

function ModalDocumentosProjeto() {
  const { atualizarDados, modalExibir, atualizarInformacoes } = useContext(ModalEstadoContext)
  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");

  const [processando, setProcessando] = useState(false);
  const [arquivoSelecionado, setArquivoSelecionado] = useState<File>();
  const [tituloDocumento, setTituloDocumento] = useState("");

  const [documentosLista, setDocumentosLista] = useState<paramsListaDocumentos[]>([]);

  const handleChangeDocumento = (event: FormEvent) => {

    const target = event.target as HTMLInputElement
    const files = target.files as FileList;

    if (files && files.length > 0) {
      setArquivoSelecionado(files[0]);
    }
  };

  const cadastrarDocumento = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true)

    if (!tituloDocumento || !arquivoSelecionado) {
      toast.info("Preencha os campos obrigatórios para cadastrar um documento.")
      return setProcessando(false)
    }

    if (!idProjeto) return toast.error("Projeto não encontrado para adicionar o Documento.")

    try {

      const payload = {
        tituloDocumento,
        idProjeto,
        arquivoSelecionado
      }

      const resposta = await cadastrarDocumentoProjeto(payload)

      if (resposta.status === 201) {
        setProcessando(false)
        atualizarDados()
        toast.success("Documento Cadastrado com Sucesso.")

        return
      }

    } catch (error: any) {

      setProcessando(false)
      toast.error("Erro ao Cadastrar Documento.")

      return
    }
  }

  const handleDownload = async (url: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const link = document.createElement("a");

      const objectURL = URL.createObjectURL(blob);

      link.href = objectURL;

      link.download = nomeDocumento(url)

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(objectURL);
    } catch (error) {
      toast.error("Erro ao baixar o documento");
    }
  };

  const substituirDocumento = (idDocumento: number) => {

    const input = document.createElement('input')
    input.type = 'file'
    input.accept = "image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"

    input.onchange = async (event: Event) => {

      const target = event.target as HTMLInputElement

      if (target.files && target.files.length > 0) {

        const file = target.files[0]
        setProcessando(true)

        try {

          const payload = {
            doc: file
          }

          const resposta = await substituirDocumentoProjeto(criptografarDado(idDocumento.toString()), payload)

          if (resposta.status === 200) {

            toast.success("Documento Substituido com Sucesso.")

            setProcessando(false)
            atualizarDados()

            return
          }

        } catch (error: any) {

          if (error.response.status === 405) {
            setProcessando(false)
            toast.warning('Documento Orignal não Encontrato')
          }

          if (error.response.status === 406) {
            setProcessando(false)
            toast.warning('Arquivo Original não Encontrado')
          }

          setProcessando(false)
          toast.error("Erro ao Substituir o Documento.")

          return
        }
      }
    }

    input.click()
  }


  const nomeDocumento = (url: string) => {
    const nomeArray = url.split('/')
    return nomeArray[nomeArray.length - 1]
  }

  const deletarDocumento = async (idDocumento: number) => {
    setProcessando(true)
    try {
      const idDocumentoCript = criptografarDado(idDocumento.toString())
      const resposta = await deletarDocumentoController(idDocumentoCript)
      if (resposta.status === 204) {
        toast.success("Documento deletado com Sucesso.")
        setProcessando(false)
        atualizarDados()
      }
    } catch (error) {
      toast.error("Erro ao Deletar Documento")
      setProcessando(false)
    }
  }

  useEffect(() => {
    const listarDocumentos = async () => {
      if (!idProjeto) return toast.error("Projeto não encontrado para adicionar o Documento.")
      const idProjetoCript = encodeURIComponent(idProjeto)
      setProcessando(true)
      try {

        const resposta = await listarProjetosDocumentos(idProjetoCript)
        if (resposta.status === 200) {
          setDocumentosLista(resposta.data)
          setProcessando(false)
        }
      } catch (error) {
        setProcessando(false)
        toast.error("Erro ao listar os Documento.")
      }
    }
    listarDocumentos()
  }, [idProjeto, atualizarInformacoes])

  return (
    <div id='fundoModal'>
      <section className={'containerModalCentro'}>
        <span className='novoContainerTitulo'>
          <h1>Listar Documentos</h1>
        </span>

        <form className="formModalNovo" onSubmit={cadastrarDocumento}>
          <section>
            <span>
              {documentosLista.length > 0 ? documentosLista.map((documento) => (
                <div className="container-show-list" key={documento.id}>
                  <div className="container-show-list-left">
                    <IoIosDocument />
                    <p>{documento.tituloDocumento}</p>
                  </div>
                  <div className="container-show-list-right">
                    {!usuarioExterno && <MdAutorenew onClick={() => substituirDocumento(documento.id)} title="Substituir Documento" />}
                    <MdOpenInNew onClick={() => window.open(documento.doc, "_blank")} title="Abrir documento" />
                    <IoMdDownload onClick={() => handleDownload(documento.doc)} title="Baixar documento" />
                    {!usuarioExterno && <MdDelete onClick={() => deletarDocumento(documento.id)} title="Deletar documento" />}
                  </div>
                </div>
              )) : <p>Nenhum Documento Adicionado.</p>}
            </span>
          </section>
          {!usuarioExterno && <section>
            <span>
              <details className="details-container-tags">
                <summary>
                  Adicionar Documentos
                </summary>
                <section className="containerDocumento">
                  <span>
                    <input type="text" name="" onChange={(e) => setTituloDocumento(e.target.value)} placeholder="Titulo do Documento" maxLength={100} required />
                  </span>
                </section>
                <div className='containerAnexarDoc'>
                  <input
                    type="file"
                    accept="image/*,.pdf,.doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    onChange={(e) => handleChangeDocumento(e)}
                    required
                  />
                  <Button type='submit' cor='salvar' isLoading={processando}>
                    {!processando && 'Adicionar'}
                    {processando && <Loader isLoading={processando} />}
                  </Button>
                </div>
              </details>
            </span>
          </section>}
          <span className="botoesContainer">
            <Button type="button" cor="cancelar" isLoading={processando} onClick={() => modalExibir("")}>
              Cancelar
            </Button>
          </span>
        </form>
      </section>
    </div>
  );
}

export default ModalDocumentosProjeto;